/* Curated featured vendors per category.
   Slugs are used in routes (/vendors/:slug) and as React keys.
   Keep category keys in sync with CATEGORIES in pages/Category.jsx. */

export const VENDORS = {
  "dj-papz": {
    slug: "dj-papz",
    name: "DJ Papz",
    category: "djs",
    categoryTitle: "DJs",
    image: "/vendors/papz.jpg",
    portrait: "/vendors/dj-papz/portrait.jpg",
    stats: [
      { label: "Location", value: "UK & International" },
      { label: "Weddings completed", value: "400+" },
    ],
    gallery: [
      "/vendors/dj-papz/g1.jpg",
      {
        type: "video",
        src: "/vendors/dj-papz/dr.mp4",
        poster: "/vendors/dj-papz/dr-poster.jpg",
        alt: "Dominican Republic",
      },
      "/vendors/dj-papz/g2.jpg",
      {
        type: "video",
        src: "/vendors/dj-papz/mm.mp4",
        poster: "/vendors/dj-papz/mm-poster.jpg",
        alt: "Papz MM",
      },
      "/vendors/dj-papz/g5.jpg",
      "/vendors/dj-papz/g4.jpg",
      "/vendors/dj-papz/g3.jpg",
    ],
    bio: [
      "DJ Papz is a high-energy, detail-driven DJ & host specialising in weddings, receptions and private events, known for creating packed dancefloors and a smooth, stress-free flow from start to finish. Whether it's a traditional day event, a full evening reception, or a mixed crowd with different age groups and cultures, Papz focuses on one thing: getting the right music at the right moment — and keeping the vibe consistent all night.",
      "With a strong background in Tamil / South Asian weddings and celebrations, DJ Papz blends the best of Tamil classics, modern Kollywood, and party anthems with Afrobeats, Hip-Hop, R&B, Bashment and commercial hits. The goal is always the same: make sure everyone feels included — from the elders enjoying the nostalgia to the younger crowd turning up on the dancefloor. Every set is mixed live with clean transitions, smart pacing and real crowd-reading, so the energy builds naturally without forcing it.",
      "DJ Papz also supports clients beyond just playing music. From the first consultation, you'll get guidance on entrance songs, key moments (first dance, cake cut, speeches, performances), and how to structure the evening so it runs smoothly. If you need a confident voice on the mic, Papz can also provide MC hosting, making announcements clearly, coordinating with your venue and planner, and keeping timings on track without killing the vibe.",
      "Professionalism and reliability are non-negotiable. DJ Papz comes prepared with a clean, professional setup and a mindset built around planning, communication and execution — including soundchecks, coordination with your team, and backup-ready preparation. The result is simple: your event feels organised, the atmosphere feels premium, and your guests remember the night for the right reasons.",
      "If you're looking for a DJ who understands culture, reads the room properly, and brings both energy and structure to your day — DJ Papz is the one.",
    ],
    services: [
      "Professional DJ performance (mixing + reading the crowd)",
      "Music planning & consultation (pre-event call, vibe/genre planning)",
      "Custom playlists & edits (entrances, first dance, special moments)",
      "MC / hosting (announcements, guiding the schedule, crowd engagement)",
      "Timeline / itinerary support (help structure key moments + pacing)",
      "Sound system supply & setup (speakers, subwoofers, microphones)",
      "Wireless microphones (speeches, ceremonies, announcements)",
      "DJ booth & controller / mixer setup",
      "Dancefloor lighting (party lights, wash lighting, effects)",
      "Uplighting / room ambience lighting",
      "Fog / haze / special effects",
      "LED screen / visuals coordination (content timing with venue)",
      "Backup equipment + contingency planning",
      "Set-up / soundcheck / coordination with venue & planner",
    ],
  },
  "dj-nitu": {
    slug: "dj-nitu",
    name: "DJ Nitu",
    category: "djs",
    categoryTitle: "DJs",
    image: "/vendors/nitu.jpg",
    stats: [
      { label: "Location", value: "UK & International" },
      { label: "Weddings completed", value: "250+" },
    ],
    gallery: [
      "/vendors/dj-nitu/g1.jpg",
      "/vendors/dj-nitu/g2.jpg",
      "/vendors/dj-nitu/g3.jpg",
      "/vendors/dj-nitu/g4.jpg",
    ],
    portrait: "/vendors/dj-nitu/portrait.jpg",
    bio: [
      "I'm a DJ and production specialist dedicated to delivering an exceptional experience from start to finish. My approach is simple: quality over quantity. Every detail, from LED screens, sound, lighting, custom dancefloors and more, to clear and professional client communication, is handled with care to ensure your wedding feels seamless, personal, and unforgettable.",
      "With a strong reputation backed by consistent client feedback, I've had the privilege of performing at some of London's most prestigious venues, including the Natural History Museum, as well as the InterContinental London – The O2, Grosvenor House Hotel, and Meridian Grand, just to name a few. I've also delivered weddings internationally in countries such as Sri Lanka, Malaysia, and France. Whether it's an intimate celebration or a large-scale reception, my focus remains the same — delivering high-quality production and outstanding customer service that speaks for itself.",
    ],
    services: [
      "DJ",
      "MC",
      "Production (LED Screen, Lighting, Sound, Dancefloors, etc.)",
    ],
  },
  "sooriya-production-services": {
    slug: "sooriya-production-services",
    name: "Sooriya Production Services",
    category: "production",
    categoryTitle: "Production",
    image: "/vendors/sooriya/banner.jpg",
    bannerPosition: "center 35%",
    tileImage: "/vendors/sam.jpg",
    portrait: "/vendors/sooriya/portrait.jpg",
    tagline:
      "Lighting, sound and staging that transforms any venue into an immersive moment.",
    stats: [
      { label: "Location", value: "UK & International" },
      { label: "Weddings completed", value: "500+" },
    ],
    gallery: [
      "/vendors/sooriya/g1.jpg",
      "/vendors/sooriya/g2.jpg",
      {
        type: "video",
        src: "/vendors/sooriya/intercon.mp4",
        poster: "/vendors/sooriya/intercon-poster.jpg",
        alt: "Intercon stage build",
      },
      "/vendors/sooriya/g3.jpg",
    ],
    bio: [
      "Sooriya Production Services stands out because they don't just provide equipment — they elevate your entire wedding experience. Their team combines technical mastery with genuine creative flair, transforming any venue into a beautifully lit, immersive space that feels personal to you.",
      "With flawless sound, elegant lighting, and seamless behind-the-scenes coordination, they ensure every moment flows effortlessly while you stay fully present on your day. Whether it's an intimate ceremony or a large-scale celebration, they offer tailored support, innovative ideas, and high-quality AV and staging that bring your vision to life with precision and heart.",
      "Choosing Sooriya Production Services means choosing a team dedicated to making your wedding shine in the most unforgettable way.",
    ],
    services: [
      "Lighting",
      "Screens",
      "Audio",
      "Staging",
      "Rigging",
      "Dance floors",
      "Sparklers",
      "Dry ice",
      "Haze",
      "Backline",
    ],
  },
  "jeyash-luxmanan": {
    slug: "jeyash-luxmanan",
    name: "Jeyash Luxmanan",
    category: "video-photo",
    categoryTitle: "Videography & Photography",
    image: "/vendors/jeyash/g1.jpg",
    tileImage: "/vendors/jeyash/portrait.webp",
    portrait: "/vendors/jeyash/portrait.webp",
    stats: [
      { label: "Location", value: "UK & International" },
      { label: "Weddings completed", value: "700+" },
    ],
    gallery: [
      "/vendors/jeyash/g1.jpg",
      "/vendors/jeyash/g2.jpg",
      "/vendors/jeyash/g3.jpg",
      "/vendors/jeyash/g4.jpg",
      "/vendors/jeyash/g5.jpg",
      "/vendors/jeyash/g6.jpg",
      "/vendors/jeyash/g7.jpg",
      "/vendors/jeyash/g8.jpg",
      "/vendors/jeyash/g9.jpg",
      "/vendors/jeyash/g10.jpg",
      "/vendors/jeyash/g11.jpg",
      "/vendors/jeyash/g12.jpg",
      "/vendors/jeyash/g13.jpg",
      "/vendors/jeyash/g14.jpg",
      "/vendors/jeyash/g15.jpg",
      "/vendors/jeyash/g16.jpg",
      "/vendors/jeyash/g17.jpg",
      "/vendors/jeyash/g18.jpg",
    ],
    bio: [
      "Jeyash Luxmanan approaches weddings with an editorial eye and a documentary heart. Drawn to light, movement, and quiet emotion, his work is shaped by the moments that often go unnoticed, the glance across a room, the anticipation before a ceremony, the celebration that unfolds naturally. Blending refined composition with honest storytelling, he creates imagery that feels both contemporary and timeless, preserving each wedding with elegance, depth, and intention.",
    ],
    services: ["Photography", "Videography"],
  },
  designa: {
    slug: "designa",
    name: "Designa",
    category: "wedding-cakes",
    categoryTitle: "Wedding Cakes",
    image: "/vendors/designa/portrait.png",
    tileImage: "/vendors/designa/portrait.png",
    portrait: "/vendors/designa/portrait.png",
    stats: [
      { label: "Location", value: "UK" },
      { label: "Weddings completed", value: "50+" },
    ],
    gallery: [
      "/vendors/designa/c1.webp",
      "/vendors/designa/c2.webp",
      "/vendors/designa/c3.webp",
      "/vendors/designa/c4.webp",
      "/vendors/designa/c5.webp",
      "/vendors/designa/c6.webp",
      "/vendors/designa/c7.webp",
      { type: "video", src: "/vendors/designa/video1.mp4" },
    ],
    galleryOrientation: "portrait",
    bio: [
      "At Designa Cake Hire, we offer luxury faux wedding cake rentals that let you achieve the statement cake you've always dreamed of—without the cost or waste of a traditional large wedding cake. Our handcrafted display cakes are beautifully styled to complement your wedding and are fully non-edible, designed purely for display.",
      "Each cake includes a discreet cutting feature so you can still enjoy those iconic cake-cutting and cake-feeding moments and photographs. It's a smarter, more sustainable way to create a breathtaking centrepiece while making the most of your wedding budget.",
    ],
    services: ["Luxury faux cake hire", "Real cake cutting & feeding feature"],
  },
  asha: {
    slug: "asha",
    name: "Stories by Asha",
    category: "content-creation",
    categoryTitle: "Content Creation",
    image: "/vendors/asha/main.jpg",
    tileImage: "/vendors/asha.jpg",
    tagline:
      "Wedding content creator · capturing genuine moments behind the scenes.",
    portrait: "/vendors/asha/portrait.jpg",
    stats: [
      { label: "Location", value: "UK & International" },
      { label: "Weddings completed", value: "500+" },
    ],
    gallery: [
      { type: "video", src: "/vendors/asha/g1.mp4" },
      { type: "video", src: "/vendors/asha/g2.mp4" },
      { type: "video", src: "/vendors/asha/g3.mp4" },
      { type: "video", src: "/vendors/asha/g4.mp4" },
      { type: "video", src: "/vendors/asha/g5.mp4" },
      { type: "video", src: "/vendors/asha/g6.mp4" },
      { type: "video", src: "/vendors/asha/g7.mp4" },
      { type: "video", src: "/vendors/asha/g8.mp4" },
    ],
    galleryOrientation: "portrait",
    bio: [
      "I believe your wedding memories deserve more than just beautiful images — they deserve a story. Established at the start of the millennium, our hand-picked team proudly specialises in Asian Weddings and have grown exponentially due to previous client recommendations.",
      "We offer both male and female photographers and videographers, and pride ourselves on making you feel relaxed and comfortable on your big day. From natural candid moments to lively celebrations, we're here to capture your day with heart, soul, and timeless quality.",
    ],
    services: ["Behind the scenes content"],
  },
};

export const VENDORS_BY_CATEGORY = Object.values(VENDORS).reduce(
  (acc, vendor) => {
    (acc[vendor.category] = acc[vendor.category] || []).push(vendor);
    return acc;
  },
  {}
);
